import { isNullOrUndefined } from 'helpers/ts-helpers';
import parse from 'url-parse';

import { useHasActivatedBetaFeatures } from './useHasActivatedBetaFeatures';

const LOCAL_HOSTNAME = 'localhost';
const DEV_HOSTNAME = 'drillx-so-front-d.drillx.iasp.tgscloud.net';
// TODO: ESK-511 - remove this hostname

const IN_DEVELOPMENT_HOSTNAMES = [LOCAL_HOSTNAME, DEV_HOSTNAME];

const urlData = parse(window.location.href, true);

const shouldShowInDevelopmentFeature = (hasActivatedBetaFeatures: boolean | null) =>
  hasActivatedBetaFeatures === true ||
  (IN_DEVELOPMENT_HOSTNAMES.includes(urlData.hostname) &&
    isNullOrUndefined(hasActivatedBetaFeatures));

export const useIsDev = () => {
  const { hasActivatedBetaFeatures } = useHasActivatedBetaFeatures();
  const r = shouldShowInDevelopmentFeature(hasActivatedBetaFeatures || false);

  return r;
};
